<script>
    const dataState = [];
    export let detail;
    export let getSession;
    export let CheckBox = true;
    /**
     *
     * @param {string}object
     */
    function uncheckPrev() {
        for (let i = 0; i < detail.length; i++) {
            if (dataState[i]) {
                dataState[i] = false;
            }
        }
    }
    if (getSession != undefined) {
        for (let i = 0; i < detail.length; i++) {
            if (detail[i].session === getSession) {
                dataState[i] = true;
                CheckBox = false;
            }
        }
    }
    $: for (let i = 0; i < detail.length; i++) {
        if (dataState[i] == true) {
            CheckBox = false;
            break;
        } else {
            CheckBox = true;
        }
    }
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<div class="desktop">
    <section>
        <form>
            <table class="table-design">
                <tr style="background-color:#3c74c0;">
                    <th>Sessions</th>
                    <th>Location</th>
                    <th>Dates</th>
                    <th>Duration</th>
                    <th>Application Deadline</th>
                    <th />
                </tr>
                {#each detail as data, id}
                    <tr class="data-row">
                        <td style="width: 17vw;">{@html data.session}</td>
                        <td>{data.location}</td>
                        <td>{data.dates}</td>
                        <td>{data.duration}</td>
                        <td>{data.deadline}</td>
                        <td
                            ><input
                                bind:checked={dataState[id]}
                                on:click={() => {
                                    if (dataState[id]) {
                                        dataState[id] = false;
                                    } else {
                                        uncheckPrev();
                                        dataState[id] = true;
                                        getSession = data.session;
                                    }
                                }}
                                class="checkbox"
                                type="checkbox"
                                required={CheckBox}
                            /></td
                        >
                    </tr>
                {/each}
            </table>
        </form>
    </section>
</div>
<div class="mobile">
    <div class="sessions-div">
        {#each detail as data,id}
            <div class="session-div">
                <div>
                    <input
                        bind:checked={dataState[id]}
                        on:click={() => {
                            if (dataState[id]) {
                                dataState[id] = false;
                            } else {
                                uncheckPrev();
                                dataState[id] = true;
                                getSession = data.session;
                            }
                        }}
                        class="checkbox-mobile" 
                        type="checkbox"
                        required={CheckBox}
                    />
                </div>
                <div class="session-heading">
                    <p> Sessions {id + 1} </p>
                </div>
            </div>
        {/each}
    </div>

    <div class="all-content">
        {#each detail as data,id}
            <div class="content-div">
                <div style="width: 25vw;">
                    <p>{data.session}</p>
                </div>
                <div>
                    <p>{data.location}</p>
                </div>
                <div style="width: 34vw;">
                    <p>{data.dates}</p>
                </div>
                <div>
                    <p>{data.duration}</p>
                </div>
                <div>
                    <p>{data.deadline}</p>
                </div>
            </div>
        {/each}
    </div>
    
</div>

<style>
    table {
        border-collapse: collapse;
        border-radius: 0.661vw;
        overflow: hidden;
        width: 69.511vw;
        margin-left: 4.96vw;
    }

    th {
        padding: 1vw;
        background: #3c74c0;
        color: white;
        text-align: center;
        font-size: 0.926vw;
        font-weight: 400;
    }
    .data-row {
        padding: 1vw;
        background: #e5eff7;
        color: #00204b;
        font-size: 0.926vw;
        font-weight: 400;
        text-align: center;
    }
    td {
        padding: 1vw;
        border-right: 0.1vw solid #b3cbe6;
    }
    td:nth-child(6) {
        border-right: none;
    }
    .checkbox {
        width: 1.389vw;
        height: 1.323vw;
        border-radius: 0.198vw;
        border: 0.132vw solid rgba(60, 136, 195, 1);
        opacity: 40;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .sessions-div{
            display: flex;
            height: 10.556vw;
            background-color: #3C74C0;
            max-width: fit-content;
            min-width: 41.671vw;
            justify-content: center;
            margin: auto;
            border-top-left-radius: 2.5vw;
            border-top-right-radius: 2.5vw;
            margin-top: 12vw;
        }
        .session-div{
            display: flex;
            gap: 4vw;
            width: 41.671vw;
            align-items: center;
            padding-left: 3vw;
        }
        .session-heading p{
            margin-bottom: 0;
            color: white;
            font-size: 3.056vw;
            font-weight: 400;
        }
        .all-content{
            display: flex;
            height: 63.114vw;
            max-width: fit-content;
            min-width: 41.671vw;
            justify-content: center;
            margin: auto;
            border-bottom-left-radius: 2.5vw;
            border-bottom-right-radius: 2.5vw;
            border-left: 0.178vw solid #3C74C0;
            border-bottom: 0.178vw solid #3C74C0;
            margin-top: -2vw;
            gap: 0.99vw;
            margin-bottom: 11vw;
            background-color: #e5eff7;
        }
        .content-div{
            width: 37.6vw;
            display: flex;
            flex-direction: column;
            gap: 5.5vw;
            padding-top: 5.556vw;
            margin-left: 3.435vw;
            border-right: 0.178vw solid #3C74C0;
        }
        .content-div:nth-last-child(1){
            border-bottom-right-radius: 2.5vw;
        }
        .content-div p{
            margin-bottom: 0;
            font-size: 3.056vw;
            font-weight: 400;
        }
    }
</style>
